export default __webpack_public_path__ + "static/media/geracao_servico_vertical.373ef650.png";